import React, { useState } from 'react';
import { Login } from './components/Login';
import { Hero } from './components/Hero';
import { Schedule } from './components/Schedule';
import { Info } from './components/Info';
import { PackingList } from './components/PackingList';
import { KnowBeforeYouGo } from './components/KnowBeforeYouGo';
import { Gallery } from './components/Gallery';
import { Rsvp } from './components/Rsvp';
import { Footer } from './components/Footer';
const UNLOCK_KEY = 'kanchella_unlocked';
export function App() {
  const [isUnlocked, setIsUnlocked] = useState(() => typeof window !== 'undefined' && window.localStorage.getItem(UNLOCK_KEY) === 'true');
  const handleUnlock = () => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(UNLOCK_KEY, 'true');
    }
    setIsUnlocked(true);
  };
  if (!isUnlocked) {
    return <Login onUnlock={handleUnlock} data-id="element-0" data-mp="28sbad0uf2z52" />;
  }
  return <main className="w-full min-h-full bg-[var(--cream)]" data-id="element-1" data-mp="23u9u0nodldxa">
      <Hero data-id="element-2" data-mp="3ijxqiu0iq6lh" />
      <Schedule data-id="element-3" data-mp="3ik7k0rkruvvx" />
      <Info data-id="element-4" data-mp="3ikqytzf4l45q" />
      <PackingList data-id="element-5" data-mp="3ij64a9st9l7v" />
      <KnowBeforeYouGo data-id="element-6" data-mp="3ijpd910hgz9r" />
      <Gallery data-id="element-7" data-mp="3mlja0y7k5j4n" />
      <Rsvp data-id="element-8" data-mp="3mlat8v8bdto6" />
      <Footer data-id="element-9" data-mp="3mkrefndynled" />
    </main>;
}